import { ImportProvider } from '../../../interface';
import { displayConfirmLeaveModal, resetOauthDraft } from '../../../logic/draft/oauthDraft/oauthDraft.actions';
import {
    selectOauthDraftProvider,
    selectOauthDraftStepConfirmModalDisplay,
    selectOauthImportStateStep,
} from '../../../logic/draft/oauthDraft/oauthDraft.selector';
import { useEasySwitchDispatch, useEasySwitchSelector } from '../../../logic/store';
import ConfirmLeaveModal from '../ConfirmLeaveModal/ConfirmLeaveModal';
import StepInstructionsGoogle from './StepInstructions/StepInstructionsGoogle';
import StepLoadingImporter from './StepLoading/StepLoadingImporter';
import StepLoadingImporting from './StepLoading/StepLoadingImporting';
import StepPrepare from './StepPrepareOAuth/StepPrepareOAuth';
import StepSuccess from './StepSuccess/StepSuccess';
import useOAuthModal from './useOAuthModal';

const OAuthModal = () => {
    const dispatch = useEasySwitchDispatch();

    const step = useEasySwitchSelector(selectOauthImportStateStep);
    const provider = useEasySwitchSelector(selectOauthDraftProvider);
    const confirmLeave = useEasySwitchSelector(selectOauthDraftStepConfirmModalDisplay);

    const { triggerOAuth, initialLoading } = useOAuthModal();

    const handleClose = () => {
        dispatch(resetOauthDraft());
    };

    const handleContinue = () => {
        dispatch(displayConfirmLeaveModal(false));
    };

    return (
        <>
            {step === 'products' && initialLoading && <StepLoadingImporter onClose={handleClose} />}
            {step === 'instructions' && provider === ImportProvider.GOOGLE && (
                <StepInstructionsGoogle triggerOAuth={triggerOAuth} />
            )}
            {step === 'loading-importer' && <StepLoadingImporter onClose={handleClose} />}
            {step === 'prepare-import' && <StepPrepare />}
            {step === 'importing' && <StepLoadingImporting />}
            {step === 'success' && <StepSuccess />}
            {confirmLeave && <ConfirmLeaveModal handleClose={handleClose} handleContinue={handleContinue} />}
        </>
    );
};

export default OAuthModal;
